var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"domRequest",staticClass:"page page-request"},[_c('RequestData',{attrs:{"item":_vm.item,"mode":_vm.mode,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }